import {
  horizontalListSortingStrategy,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { IWidgetType } from '@framework/engine';

/**
 * Ritorna la strategia di sorting da utilizzare per il layout dei widget
 */
export function dndLayoutSortingStrategy(widgetType: IWidgetType<any>) {
  switch (widgetType.childrenLayoutStrategy) {
    case 'horizontal':
      return horizontalListSortingStrategy;
    case 'vertical':
    default:
      return verticalListSortingStrategy;
  }
}
